<div class="text-line">
	<span>
		<ng-content></ng-content>
	</span>
</div>
